import { IUnifiedSubscription, TPurchaseBillingPeriod } from '../../../common/purchases';
import { TXsollaSubscriptionTier, VALID_SUBSCRIPTION_TIERS } from '../../../common/xsollaConfig';
import {
  getActiveSubscriptionBySource,
  getSubscriptionTierSlug
} from './userSubscriptionsSettingsDisplay';

export type TXsollaPlanBillingPeriod = Extract<TPurchaseBillingPeriod, 'monthly' | 'annual'>;

export type TXsollaRequestedPlanTarget = {
  tier: TXsollaSubscriptionTier;
  billingPeriod: TXsollaPlanBillingPeriod;
};

export type TXsollaActivePlanState = {
  tier: TXsollaSubscriptionTier | null;
  billingPeriod: IUnifiedSubscription['billingPeriod'];
  subscriptionEndsAt: string | null;
  isNonRenewing: boolean;
};

export function getActiveXsollaPlanState(subscriptions: IUnifiedSubscription[]): TXsollaActivePlanState | null {
  const activeXsollaSubscription = getActiveSubscriptionBySource(subscriptions, 'xsolla');
  if (!activeXsollaSubscription) {
    return null;
  }

  const tierSlug = getSubscriptionTierSlug(activeXsollaSubscription.productCode);
  const tier = tierSlug && VALID_SUBSCRIPTION_TIERS.includes(tierSlug as TXsollaSubscriptionTier)
    ? tierSlug as TXsollaSubscriptionTier
    : null;

  return {
    tier,
    billingPeriod: activeXsollaSubscription.billingPeriod ?? null,
    subscriptionEndsAt: activeXsollaSubscription.subscriptionEndsAt,
    isNonRenewing: activeXsollaSubscription.purchaseStatus === 'non_renewing'
  };
}

export function doesXsollaActivePlanMatchTarget(
  subscriptions: IUnifiedSubscription[],
  target: TXsollaRequestedPlanTarget
): boolean {
  const activeXsollaPlan = getActiveXsollaPlanState(subscriptions);

  return !!activeXsollaPlan &&
    activeXsollaPlan.tier === target.tier &&
    activeXsollaPlan.billingPeriod === target.billingPeriod;
}
